function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clientContractEditApi, clientContractSaveApi, contractList as _contractList, clientNameApi } from '@/api/enterprise';
import { configQuickShowApi } from '@/api/setting';
export default {
  name: 'ContractInfo',
  props: {
    formInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      drawer: false,
      direction: 'rtl',
      rules: {
        title: '',
        eid: '',
        price: undefined,
        startTime: '',
        category_id: '',
        is_abnormal: 0,
        endTime: '',
        mark: '',
        sign_status: 0,
        // 签约状态
        contract_no: '' // 合同编号
      },
      nameList: [],
      options: [],
      handleData: {},
      rule: {
        title: [{
          required: true,
          message: this.$t('customer.placeholder26'),
          trigger: 'blur'
        }],
        price: [{
          required: true,
          message: this.$t('customer.placeholder28'),
          trigger: 'blur'
        }],
        startTime: [{
          required: true,
          message: this.$t('customer.placeholder29'),
          trigger: 'blur'
        }],
        sign_status: [{
          required: true,
          message: '请选择签约状态',
          trigger: 'change'
        }],
        eid: [{
          required: true,
          message: '请选择客户名称',
          trigger: 'change'
        }],
        endTime: [{
          required: true,
          message: this.$t('customer.placeholder30'),
          trigger: 'blur'
        }],
        category_id: [{
          required: true,
          message: '请选择合同分类',
          trigger: 'change'
        }]
      },
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),
      editIndex: 0,
      autosize: {
        minRows: 6
      }
    };
  },
  watch: {
    formInfo: {
      handler: function handler(nVal) {
        this.clientNameList();
        if (nVal.edit) {
          if (nVal.editIndex === undefined) {
            this.rules = {
              eid: nVal.data.eid,
              title: nVal.data.title,
              price: nVal.data.price,
              category_id: nVal.data.category_id,
              startTime: nVal.data.start_date,
              endTime: nVal.data.end_date == '0000-00-00' ? '' : nVal.data.end_date,
              mark: nVal.data.mark,
              is_abnormal: nVal.data.is_abnormal,
              contract_no: nVal.data.contract_no,
              sign_status: nVal.data.sign_status
            };
          }
        } else {
          if (nVal.id) {
            this.rules.eid = nVal.id;
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    reset: function reset() {
      this.rules = {
        title: '',
        price: undefined,
        category_id: '',
        startTime: '',
        endTime: '',
        eid: '',
        mark: '',
        contract_no: '',
        sign_status: 0
      };
    },
    // 获取客户列表
    clientNameList: function clientNameList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return clientNameApi();
            case 2:
              result = _context.sent;
              _this.nameList = result.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 获取合同分类列表
    contractList: function contractList() {
      var _this2 = this;
      _contractList().then(function (res) {
        _this2.options = res.data;
      });
    },
    categoryType: function categoryType() {
      this.rules.title = this.$refs['myCascader'].getCheckedNodes()[0].label;
    },
    categoryName: function categoryName(val) {
      // this.rules.eid = val;
    },
    // 提交
    handleConfirm: function handleConfirm() {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        if (_this3.rules.endTime && new Date(_this3.rules.startTime) > new Date(_this3.rules.endTime)) {
          return _this3.$message.error('结束时间不能小于开始时间');
        }
        _this3.$refs.form.validate(function (valid) {
          if (valid) {
            var name = _this3.nameList.filter(function (item) {
              return item.id == _this3.rules.eid;
            });
            _this3.formInfo.name = name[0].name;
            var data = {
              eid: _this3.rules.eid,
              title: _this3.rules.title,
              category_id: _this3.rules.category_id,
              price: _this3.rules.price,
              start_date: _this3.$moment(_this3.rules.startTime).format('YYYY-MM-DD'),
              end_date: _this3.rules.endTime ? _this3.$moment(_this3.rules.endTime).format('YYYY-MM-DD') : '',
              is_abnormal: _this3.rules.is_abnormal,
              mark: _this3.rules.mark,
              contract_no: _this3.rules.contract_no,
              sign_status: _this3.rules.sign_status
            };
            _this3.formInfo.edit ? _this3.clientContractEdit(_this3.formInfo.data.id, data) : _this3.clientContractSave(data);
            resolve(valid);
          }
        });
      });
    },
    handleEmit: function handleEmit() {
      this.$emit('handleContract', this.handleData);
    },
    // 保存合同
    clientContractSave: function clientContractSave(data) {
      var _this4 = this;
      this.handleData.loading = true;
      clientContractSaveApi(data).then(function (res) {
        _this4.handleData.loading = false;
        _this4.handleData.success = 1;
        _this4.$set(_this4.handleData, 'title', _this4.rules.title);
        _this4.$set(_this4.handleData, 'price', _this4.rules.price);
        _this4.$set(_this4.handleData, 'eid', _this4.rules.eid);
        _this4.$set(_this4.handleData, 'id', res.data.id);
        _this4.$set(_this4.handleData, 'category_id', _this4.rules.category_id.pop());
        _this4.$set(_this4.handleData, 'start_date', _this4.$moment(_this4.rules.startTime).format('YYYY-MM-DD'));
        _this4.$set(_this4.handleData, 'end_date', _this4.rules.endTime ? _this4.$moment(_this4.rules.endTime).format('YYYY-MM-DD') : '');
        _this4.$set(_this4.handleData, 'contract_no', _this4.rules.contract_no);
        _this4.$set(_this4.handleData, 'sign_status', _this4.rules.sign_status);
        _this4.$set(_this4.handleData, 'mark', _this4.rules.mark);
        _this4.$set(_this4.handleData, 'name', _this4.formInfo.name);
        _this4.handleEmit();
        _this4.reset();
      }).catch(function (error) {
        _this4.handleData.loading = false;
        _this4.handleEmit();
      });
    },
    // 修改合同
    clientContractEdit: function clientContractEdit(id, data) {
      var _this5 = this;
      this.handleData.loading = true;
      this.handleEmit();
      clientContractEditApi(id, data).then(function (res) {
        _this5.handleData.loading = false;
        _this5.handleData.success = 1;
        _this5.handleData.title = _this5.rules.title;
        _this5.handleData.editIndex = _this5.editIndex++;
        _this5.handleData.price = _this5.rules.price;
        _this5.handleEmit();
      }).catch(function (error) {
        _this5.handleData.loading = false;
        _this5.handleEmit();
      });
    },
    beginDate: function beginDate() {
      var self = this;
      return {
        disabledDate: function disabledDate(time) {
          if (self.rules.endTime) {
            // 如果结束时间不为空，则小于结束时间
            return new Date(self.rules.endTime).getTime() < time.getTime();
          } else {
            // return time.getTime() > Date.now( //开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    processDate: function processDate() {
      var self = this;
      return {
        disabledDate: function disabledDate(time) {
          if (self.rules.startTime) {
            // 如果开始时间不为空，则结束时间大于开始时间
            return new Date(self.rules.startTime).getTime() > time.getTime();
          } else {
            // return time.getTime() > Date.now() // 开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    }
  }
};